import React from 'react';
import { CloseButton, CloseButtonSize } from '../LiliCloseButton/CloseButton';

interface LiliDropDownValueTemplateProps {
  selectedValue: string | null;
  selectedTitle: string | null;
  title: string;
  onClear?: () => void;
  showClose?: boolean;
}

export const LiliDropDownValueTemplate = ({
  selectedValue,
  selectedTitle,
  title,
  onClear,
  showClose,
}: LiliDropDownValueTemplateProps) => (
  <div
    className='flex flex-row justify-between items-center gap-1 px-[4px]  ' //
    key={selectedValue || selectedTitle}
  >
    {!selectedValue ? (
      <p className='font-metricR text-[14px] text-bw06  w-full'>{title}</p>
    ) : (
      <p className='font-metricR text-[14px] text-bw08  w-full'>{selectedTitle}</p>
    )}
    {onClear && selectedValue && showClose && (
      <CloseButton id='s' onClick={onClear} className='w-[18px] h-[18px] mr-[0px]' size={CloseButtonSize.Small} />
    )}
  </div>
);
